var map = {
	"./banner-default.jpg": "fd25",
	"./btlft.png": "3da5",
	"./careers/banner.jpg": "58ae",
	"./careers/tab_culture.jpg": "0804",
	"./careers/tab_employees.jpg": "7c49",
	"./contact-banner-old.jpg": "d135",
	"./contact-banner.jpg": "0940",
	"./home-about-big.png": "8224",
	"./home-about.jpg": "698e",
	"./home/banners/home-banner-1.png": "9283",
	"./home/banners/home-banner-2.jpg": "74a2",
	"./home/banners/home-banner-3.jpg": "b703",
	"./home/banners/home-banner-4.jpg": "fa78",
	"./home/banners/home-banner-6.png": "7b9c",
	"./home/banners/proteas-banner.webp": "913f",
	"./home/benefits/benefit-icon-1.svg": "9ed8",
	"./home/benefits/benefit-icon-2.svg": "7cda",
	"./home/benefits/benefit-icon-3.svg": "5568",
	"./home/benefits/benefit-icon-4.svg": "b794",
	"./home/news/featured-1.jpg": "8d16",
	"./home/news/featured-icon.svg": "02bb",
	"./home/tabs/fibre-to-home.jpg": "b1b5",
	"./home/vuma-crs-big.jpg": "ffba",
	"./home/vuma-crs.jpg": "f06c",
	"./icon.png": "f8a2",
	"./menu-close.svg": "b332",
	"./news/facebook.jpg": "721e",
	"./news/twitter.jpg": "ed8e",
	"./products/BusinessFibreProduct/banners/business-page-banner.jpg": "79f6",
	"./products/BusinessFibreProduct/tabs/business-page-landlords.jpg": "6eeb2",
	"./products/BusinessFibreProduct/tabs/business-page-service-providers.jpg": "612c",
	"./products/BusinessFibreProduct/tabs/business-page-tenants.jpg": "d344",
	"./products/CorporateSocialInvestment/banners/csi-page-banner.jpg": "777d",
	"./products/CorporateSocialInvestment/tabs/csi-page-tabs-image-1.jpg": "e5c7",
	"./products/CorporateSocialInvestment/tabs/csi-page-tabs-image-2.jpg": "b9ba",
	"./products/CorporateSocialInvestment/tabs/csi-page-tabs-image-3.jpg": "1cca",
	"./products/CorporateSocialInvestment/tabs/csi-page-tabs-image-4.jpg": "5b9f",
	"./products/business/vuma-business-banner.jpg": "9957",
	"./products/core/banners/core-banner-1.jpg": "acf0",
	"./products/core/banners/core-banner-2.jpg": "abe0",
	"./products/core/core-default.png": "ff96",
	"./products/core/tab-default.jpg": "8dd6",
	"./products/core/tabs/core-connect-old.jpg": "4b23",
	"./products/core/tabs/core-connect.jpg": "ae4d",
	"./products/core/tabs/core-entertainment.jpg": "48d4",
	"./products/core/tabs/core-learn.jpg": "e2b0",
	"./products/core/tabs/core-save.jpg": "1a50",
	"./products/core/tabs/core-work.jpg": "54ce",
	"./products/core/vuma-core-banner.jpg": "69b9",
	"./products/core/vuma-fibre-process-1.svg": "2e0f",
	"./products/core/vuma-fibre-process-2.svg": "06ba",
	"./products/core/vuma-fibre-process-3.svg": "2964",
	"./products/core/vuma-fibre-process-4.svg": "63c3",
	"./products/core/vuma-fibre-process-5.svg": "bffb",
	"./products/key/key-default.jpg": "ec5d",
	"./products/key/vuma-key-banner.jpg": "e72b",
	"./products/reach/banner-default.jpg": "b22d",
	"./products/reach/banners/reach-banner-1.jpg": "9ae0",
	"./products/reach/banners/reach-banner-2.jpg": "86bd",
	"./products/reach/banners/reach-banner-3.jpg": "d683",
	"./products/reach/partners/cool-ideas.png": "3358",
	"./products/reach/partners/fly-cool-internet.png": "a4fa",
	"./products/reach/partners/home-connect.png": "2fb4",
	"./products/reach/partners/hypa.jpg": "1d49",
	"./products/reach/partners/mweb.png": "963a",
	"./products/reach/partners/sa-digital-villages.jpg": "a655",
	"./products/reach/partners/vodacom.png": "8fdd",
	"./products/reach/reach-default.jpg": "4064",
	"./products/reach/tabs/reach-connect.jpg": "0b94",
	"./products/reach/tabs/reach-entertainment.jpg": "d83d",
	"./products/reach/tabs/reach-save.jpg": "e7311",
	"./products/reach/tabs/reach-work.jpg": "cf19",
	"./products/reach/vuma-reach-banner.jpg": "3939",
	"./shop/download-arrow.svg": "3c16",
	"./shop/nav-arrow-left.svg": "03d0",
	"./shop/nav-arrow.svg": "18aa",
	"./shop/upload-arrow.svg": "5f38",
	"./tab-default.jpg": "cb3b",
	"./vuma-community-icon.svg": "b8cc",
	"./vuma-logo-pink.svg": "917a",
	"./vuma-logo.svg": "28e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";